import React from "react";
import { connect } from "react-redux";
import { FaWhatsapp } from "react-icons/fa";

function CustomChatbot(props) {
  const { number } = props;

  // Clean and normalize dynamic API WhatsApp number (no hardcoded fallback)
  const cleanNumber = (num) => {
    if (!num) return "";
    let cleaned = String(num).replace(/\D/g, "");
    if (cleaned.startsWith("03") && cleaned.length === 11) {
      cleaned = "92" + cleaned.substring(1);
    } else if (cleaned.startsWith("0092")) {
      cleaned = cleaned.substring(2);
    }
    return cleaned;
  };

  const whatsappNumber = cleanNumber(number);

  if (!whatsappNumber) {
    return null;
  }

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hello!`}
      target="_blank"
      rel="noopener noreferrer"
      className="myWhatsapp"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp
        size={38}
        style={{
          color: "#fff",
        }}
      />
    </a>
  );
}

const mapStateToProps = (state) => ({
  number:
    state?.contactDetails?.contactDetails?.data?.whatsapp_number ||
    state?.contactDetails?.contactDetails?.data?.phone_number ||
    "",
});

export default connect(mapStateToProps)(CustomChatbot);